export const TECHNICAL_ASSESSMENTS = 'assessmentCycles';
export const GET_TECHNICAL_ASSESSMENTS = `${TECHNICAL_ASSESSMENTS}/getTechnicalAssessmentsAction`;
